import { render, staticRenderFns } from "./DettaglioLotto.vue?vue&type=template&id=7943e4e0"
import script from "./DettaglioLotto.vue?vue&type=script&lang=ts"
export * from "./DettaglioLotto.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShowTabsDettaglioLottoTheLotto: require('/usr/src/nuxt-app/components/show/tabs/dettaglioLotto/TheLotto.vue').default,ShowTabsDettaglioLottoTheBeni: require('/usr/src/nuxt-app/components/show/tabs/dettaglioLotto/TheBeni.vue').default})
